//Since the avatars come from the provider name, we need a fallback image just in case the avatar has not yet been added to the assets
export const onAvatarLoadFailed = (
  event: React.SyntheticEvent<HTMLImageElement, Event>
) => {
  const img = event.target as HTMLImageElement;
  img.src = '/assets/connector-icons/rounded-logos/empty-data-rounded.svg';
};
